import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';

export default new class {
    constructor() {
        this.userFrontendDataRequest = undefined;
        this.userFrontendData = undefined;
        this.parentData = undefined;
    }

    async getUserConfirmDataByToken(token) {
        return ServerRequestUtil.get('/api/app/auth/confirmUserData', { token: token });
    }

    async confirmRegistration(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/confirmRegistration', {...registrationData });
    }

    async forgotPassword(data) {
        return ServerRequestUtil.post('api/app/auth/forgot-password', {...data });
    }

    async authChangePassword(data) {
        return ServerRequestUtil.post('api/app/auth/change-password', {...data });
    }

    async editUserAccount(data) {
        return ServerRequestUtil.post('api/app/users/edit', {...data });
    }

    async resetPassword(data) {
        return ServerRequestUtil.post('api/app/users/change-password', {...data });
    }

    async deactivate() {
        return ServerRequestUtil.post('api/app/users/deactivate');
    }

    async isSuspended() {
        return ServerRequestUtil.get('api/app/users/is-suspended');
    }

    async login(account, password, member, language, recaptchaToken) {
        return ServerRequestUtil.post('/api/app/auth/login', {
            account,
            password,
            member,
            language,
            recaptchaToken
        });
    }

    async revokeToken(token) {
        return ServerRequestUtil.post('/api/app/auth/revoke', {
            token
        });
    }

    async getClientName(redirectUrl) {
        return ServerRequestUtil.post('/api/app/auth/client/getClientName', {
            redirectUrl
        });
    }

    async clientLogin(account, password, member, language, recaptchaToken, redirectUrl) {
        return ServerRequestUtil.post('/api/app/auth/client/login', {
            account,
            password,
            member,
            language,
            recaptchaToken,
            redirectUrl
        });
    }

    async clientAutoLogin(redirectUrl, token) {
        return ServerRequestUtil.post('/api/app/auth/client/autoLogin', {
            redirectUrl,
            token
        });
    }

    async loginCreateUser(account, password, member, language, recaptchaToken) {
        return ServerRequestUtil.post('/api/app/auth/login', {
            account,
            password,
            member,
            language,
            recaptchaToken
        });
    }

    async getChildAccesses() {
        return ServerRequestUtil.get('api/app/childs/accesses');
    }

    async regenerateChildAccesses() {
        return ServerRequestUtil.get('api/app/childs/regenerate');
    }

    async forceClubIsActivated(serialNumber) {
        return ServerRequestUtil.get(`api/app/users/forceClub/is-activated?sn=${serialNumber}`);
    }

    async forceClubActivate(data) {
        return ServerRequestUtil.post('api/app/users/forceClub/activate', {...data });
    }

    async forceClubReActivate(data) {
        return ServerRequestUtil.put('api/app/users/forceClub/activate', {...data });
    }

    async isVerifiedForceClubId(fcId) {
        let r = await ServerRequestUtil.get(`/api/app/forceClub/is-verified-fcid?fcId=${fcId}`);

        return r.data.is_verified;
    }

    async isUniqueForceClubId(fcId) {
        let r = await ServerRequestUtil.get(`/api/app/forceClub/is-unique-fcid?fcId=${fcId}`);

        return r.data.is_unique;
    }

    isSubscribed(user /** userFrontendData */ ) {
        if (!user) { return false }
        if (!user.paypal) { return false }

        return user.paypal.status === '1' || user.paypal.status === '3' // STATUS_ACTIVE, STATUS_CANCELING
    }

    isChild(user /** userFrontendData */ ) {
        if (!user) { return false }

        return user.is_child;
    }

    setLogin(authData) {
        AuthUtil.setAuth(authData);
    }

    async getParentData(force) {
        if ((!this.parentData) || (force)) {
            let r = await ServerRequestUtil.get('api/app/users/parent');
            this.parentData = r.data;
        }
        return Promise.resolve(this.parentData);
    }

    async getUserFrontendData(force) {
        if ((force) || (this.userFrontendData === undefined)) {
            this.userFrontendData = await ServerRequestUtil.get('api/app/users/self');
        }
        return Promise.resolve(this.userFrontendData);
    }

    async getUserFrontendDataDetail() {
        this.userFrontendDataDetail = await ServerRequestUtil.get('api/app/token/forthing/detail');
        return Promise.resolve(this.userFrontendDataDetail);
    }

    async getUserFrontendAubeCoinDataDetail() {
        this.userFrontendDataDetail = await ServerRequestUtil.get('api/app/aube-coin/forthing/detail');
        return Promise.resolve(this.userFrontendDataDetail);
    }

    async getForceClubInfoData() {
        return ServerRequestUtil.get('api/app/users/getForceClubInfoData');
    }

    async questAvailabilityCheckData() {
        return ServerRequestUtil.get('api/app/users/check-member-availability');
    }

    isFinishedSetupAUBE(user) {
        if (!user) {
            return false;
        }

        if (
            (user.kyc && user.kyc.status === '2') &&
            (user.forceClub && user.forceClub.status === '1') &&
            (user.latestMembershipFee && !user.latestMembershipFee.is_close_to_end)
        ) {
            return true;
        }
        return false;
    }

    async mainRegistrationCheck(fcId) {
        let r = await ServerRequestUtil.get(`/api/app/forceClub/mainRegistrationCheck?fcId=${fcId}`);

        return r.data.is_unique;
    }

    async tempRegistrationCheck(fcId) {
        let r = await ServerRequestUtil.get(`/api/app/forceClub/temporaryRegistrationCheck?fcId=${fcId}`);

        return r.data.is_unique;
    }

    async resetMailRequest() {
        return ServerRequestUtil.post('api/app/users/change-mail-request');
    }

    async confirmChangeEmailRequest(data) {
        return ServerRequestUtil.post('api/app/auth/confirm-change-mail-request', {...data });
    }

    async resetMail(data) {
        return ServerRequestUtil.post('api/app/auth/change-mail', {...data});
    }

    async setChangeEmail(data) {
        return ServerRequestUtil.post('api/app/auth/confirmUserDataEmail', {...data });
    }

    //プロフィール編集
    async editUserAccountComfirm(data) {
        return ServerRequestUtil.post('api/app/users/edit-confirm', {...data });
    }
    //【ForceClub】新規会員登録 Eメール登録画面
    async createUserForceClub(data) {
        return ServerRequestUtil.post('/api/app/auth/createUser', data);
    }
    //【ForceClub】プロフィール入力
    async confirmRegistrationForceClub(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/confirmRegistrationForceClub', {...registrationData });
    }
    //【ForceClub】プロフィール入力確認
    async updateRegistrationForceClub(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/updateRegistrationForceClub', {...registrationData });
    }

    //【Aube】新規会員登録 Eメール登録画面
    async createUserAube(data) {
        return ServerRequestUtil.post('/api/app/auth/createUserNew', data);
    }
    //【Aube】プロフィール入力
    async confirmRegistrationAube(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/confirmRegistrationAube', {...registrationData });
    }

    //【Aube】プロフィール入力確認
    async updateRegistrationAube(registrationData) {
        return ServerRequestUtil.post('/api/app/auth/updateRegistrationAube', {...registrationData });
    }

    async getUserConfirmDataByMail(data) {
        return ServerRequestUtil.post('/api/app/auth/confirmUserMailData', {...data });
    }

    async checkTokenExpiration(token) {
        return ServerRequestUtil.post('/api/app/auth/checkToken', { token: token });
    }

    async checkForgotPasswordTokenExpiration(token) {
        return ServerRequestUtil.post('/api/app/auth/checkForgotPasswordToken', { token: token });
    }

    // 会員種別取得API疎通確認
    async checkGetMemberType(fcId) {
        let r = await  ServerRequestUtil.get(`/api/app/forceClub/getMemberType?fcId=${fcId}`);
        return r.data.check_result;
    }

    async get2saStatus() {
        return ServerRequestUtil.get('api/app/users/2sa/status');
    }

    async activate2sa(data) {
        return ServerRequestUtil.post('api/app/users/2sa/activate', { ...data });
    }

    async deactivate2sa(data) {
        return ServerRequestUtil.post('api/app/users/2sa/deactivate', { ...data });
    }

    async google2saLogin(data) {
        return ServerRequestUtil.post('api/app/auth/2sa/login', { ...data });
    }

    async getHecSavingApplyInfo() {
        return ServerRequestUtil.get('/api/app/membership/hecSavingApplyInfo');
    }

    async getMembershipHistory() {
        return ServerRequestUtil.get('api/app/membership/history');
    }

    async getAubeCoinMembershipHistory() {
        return ServerRequestUtil.get('api/app/aube-coin/membership/history');
    }

    async getType(email) {
        return ServerRequestUtil.post('api/app/memberinfo/getVipRankInfo',  {email:email});
    }

    async loginQuest(account, password, member, language, recaptchaToken) {
        return ServerRequestUtil.post('/api/app/auth/quest/login', {
            account,
            password,
            member,
            language,
            recaptchaToken
        });
    }

    async getQuestIdByToken(token) {
        return ServerRequestUtil.get('/api/app/auth/quest/get-quest-id-by-token', { token: token });
    }

    async getUserAubeQuestConfirmDataByToken(token) {
        return ServerRequestUtil.get('/api/app/auth/quest/confirm-user-data', { token: token });
    }
}
